import { render, staticRenderFns } from "./BaseSendEmailDialog.vue?vue&type=template&id=aea2fa50&"
import script from "./BaseSendEmailDialog.vue?vue&type=script&lang=js&"
export * from "./BaseSendEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea2fa50')) {
      api.createRecord('aea2fa50', component.options)
    } else {
      api.reload('aea2fa50', component.options)
    }
    module.hot.accept("./BaseSendEmailDialog.vue?vue&type=template&id=aea2fa50&", function () {
      api.rerender('aea2fa50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseSendEmailDialog.vue"
export default component.exports